// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "div.notification-drawer section.el-drawer__body {\n  height: 100%;\n}\ndiv.notification-drawer section.el-drawer__body div#notification-container {\n  height: 90%;\n  overflow-y: scroll;\n}", ""]);
// Exports
module.exports = exports;
